import { computeRemSize } from '@ydistri/theme';
import { CalculationStatisticStoreSourceResponse } from '@ydistri/api-sdk';
import { useMemo } from 'react';
import { useCurrency } from '../../../../../hooks/useCurrency';
import {
  EntityColumns,
  useStoreTableColumnsProvider,
} from '../../../../../hooks/useEntityTableColumnsProvider';
import { getStatisticsSourceStoresTableColumns } from './statisticsModalTableColumns';
import { ColumnsType } from 'antd/es/table';

export const useTableSourceStoreColumns = (
  displayDepartment = false,
): ColumnsType<CalculationStatisticStoreSourceResponse> => {
  const currencyId = useCurrency();
  const storeColumnsProvider = useStoreTableColumnsProvider();

  return useMemo(() => {
    const columnConfig = {
      [EntityColumns.ID]: {
        width: computeRemSize(120),
      },
      [EntityColumns.CODE]: {
        width: computeRemSize(120),
      },
    };

    const storeColumns = storeColumnsProvider<CalculationStatisticStoreSourceResponse>(
      columnConfig,
      'sourceStore',
      'Source Store',
    );

    return getStatisticsSourceStoresTableColumns(currencyId, displayDepartment, storeColumns);
  }, [currencyId, displayDepartment, storeColumnsProvider]);
};
